/**
 * Arrow Right Icon Component
 *
 * Directional arrow-right icon with official toolkit sizes.
 *
 * @module @smoothie-framework/ui/icons/arrow-right-icon
 */
import { createIconNode } from '../create-icon';
const ARROW_RIGHT_ICON = Object.freeze({
    sm: {
        viewBox: '0 0 16 16',
        paths: [
            { d: 'M13.5 8L2.5 8M10 4.5L13.5 8L10 11.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
    md: {
        viewBox: '0 0 24 24',
        paths: [
            { d: 'M6.5 12H17.5M14 15.5L17.5 12L14 8.5', stroke: 'currentColor', strokeWidth: '1px', strokeLinecap: 'round', strokeLinejoin: 'round' },
        ],
    },
});
export function ArrowRightIcon(props) {
    return createIconNode(ARROW_RIGHT_ICON, props);
}
//# sourceMappingURL=arrow-right.js.map